var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Landscaping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "z8TGNRLT6bLMJddnO3Jx~a",
    x1: 34,
    x2: 34,
    y1: 26.88,
    y2: 47.547,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 12",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z8TGNRLT6bLMJddnO3Jx~b",
    x1: 11.555,
    x2: 24.913,
    y1: 10.718,
    y2: 47.42,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 112",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21a366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z8TGNRLT6bLMJddnO3Jx~c",
    x1: 28.257,
    x2: 34.822,
    y1: -138.257,
    y2: -144.822,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 44",
    gradientTransform: "matrix(1 0 0 -1 0 -124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z8TGNRLT6bLMJddnO3Jx~d",
    x1: 11.963,
    x2: 11.963,
    y1: 31.022,
    y2: 23.931,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 19",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z8TGNRLT6bLMJddnO3Jx~e",
    x1: 8.814,
    x2: 16.054,
    y1: 4.203,
    y2: 33.306,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 101",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33c481",
    d: "M5,42H43a2,2,0,0,0,2-2V28.96875a1.99719,1.99719,0,0,0-1.99285-2.00005c-3.78582-.00122-12.24362.27645-19.00715,2.531C14.09546,32.80118,9,37,5,42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z8TGNRLT6bLMJddnO3Jx~a)",
    d: "M23,32H45a0,0,0,0,1,0,0v8a2,2,0,0,1-2,2H23a0,0,0,0,1,0,0V32A0,0,0,0,1,23,32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z8TGNRLT6bLMJddnO3Jx~b)",
    d: "M40.8451,42H5a2,2,0,0,1-2-2V28.96875A1.99719,1.99719,0,0,1,4.99285,26.9687c3.78582-.00122,12.24362.27645,19.00715,2.531,8.7884,2.92947,13.79051,6.5654,17.60067,10.84064A1.00105,1.00105,0,0,1,40.8451,42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.35,39.67c-4.24-4.75-9.43-8.07-16.71-10.66q-.42.10492-.84.24c-.27.08-.54.16-.8.25,8.79,2.93,13.79,6.57,17.6,10.84A1.00216,1.00216,0,0,1,40.85,42h1.72a1.13915,1.13915,0,0,0,.1-.19A1.96014,1.96014,0,0,0,42.35,39.67Z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.97,40.01c-4.3-4.82-9.61-8.16-17.17-10.76-.27.08-.54.16-.8.25,8.79,2.93,13.79,6.57,17.6,10.84A1.00216,1.00216,0,0,1,40.85,42h1.11a1.55953,1.55953,0,0,0,.26-.39A1.46785,1.46785,0,0,0,41.97,40.01Z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z8TGNRLT6bLMJddnO3Jx~c)",
    d: "M32,14a4,4,0,1,0,4,4A4.00018,4.00018,0,0,0,32,14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z8TGNRLT6bLMJddnO3Jx~d)",
    d: "M9.95732,11.54878h4.01219V30.32927A.67.67,0,0,1,13.30081,31H10.626a.67.67,0,0,1-.6687-.67073Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.47,27.51c-.17-.02-.33-.04-.5-.05005v2.87a.67.67,0,0,1-.67.67H10.63a.67.67,0,0,1-.67-.67V27.12c-.17-.01-.34-.02-.5-.03-.17-.01-.34-.02-.5-.03v3.27A1.673,1.673,0,0,0,10.63,32H13.3a1.673,1.673,0,0,0,1.67-1.67V27.58C14.8,27.55,14.64,27.53,14.47,27.51Z",
    opacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97,27.46v2.87a.67.67,0,0,1-.67.67H10.63a.67.67,0,0,1-.67-.67V27.12c-.17-.01-.34-.02-.5-.03v3.24a1.1715,1.1715,0,0,0,1.17,1.17H13.3a1.1715,1.1715,0,0,0,1.17-1.17V27.51C14.3,27.49,14.14,27.47,13.97,27.46Z",
    opacity: 0.07
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z8TGNRLT6bLMJddnO3Jx~e)",
    d: "M18.736,14.61658A4.49253,4.49253,0,0,0,15.5,7c-.01709,0-.03284.00482-.04987.005a3.4831,3.4831,0,0,0-6.90026,0C8.53284,7.00482,8.51709,7,8.5,7a4.49253,4.49253,0,0,0-3.236,7.61658,4.48085,4.48085,0,0,0,3.24347,8.26074,3.4804,3.4804,0,0,0,6.92578-.01837A4.48139,4.48139,0,0,0,18.736,14.61658Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Landscaping);
export default __webpack_public_path__ + "static/media/icons8-landscaping.f5cde46d5f7768b08df21408a5fb7e04.svg";
export { ForwardRef as ReactComponent };